import React, { useContext } from 'react';
import { useClients } from '../clients';
import { useABTest } from '../../extensible/ab-test-context';
export const FILTERS_EXPERIMENT_ID = 'filters-experiment';
export const NO_MORE_FASTER_SEARCH_EXPERIMENT_ID = 'peach';
export const DefaultFeatures = Object.freeze({
  isMultiSite: false
});
const ConfluenceFeatureContext = /*#__PURE__*/React.createContext(DefaultFeatures);
export const ConfluenceFeaturesProvider = ({
  children,
  features: featuresOverride
}) => {
  const {
    sites = []
  } = useClients();
  const abTest = useABTest();
  const value = {
    ...DefaultFeatures,
    ...{
      isMultiSite: sites.length > 1,
      isFasterSearchDisabled: (abTest === null || abTest === void 0 ? void 0 : abTest.experimentId) === NO_MORE_FASTER_SEARCH_EXPERIMENT_ID
    },
    ...featuresOverride
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoedValue = React.useMemo(() => value, [...Object.values(value)]);
  return /*#__PURE__*/React.createElement(ConfluenceFeatureContext.Provider, {
    value: memoedValue
  }, children);
};
export const useFeatures = () => {
  return useContext(ConfluenceFeatureContext);
};